export default "__VITE_ASSET__Zv7_dbtRkTerJzhi5biZkQ__"